import Button from '@/components/base/Button';
import { useAppUpdate } from '@/hooks/useAppUpdate';

/**
 * 新バージョンがデプロイされたときに、画面下部へ表示する更新バナー。
 *
 * PWA（とくに iOS スタンドアロン）では自動で読み直されないことがあるため、
 * 「更新する」を押すと確実なリロードで最新版へ入れ替える。
 */
export default function AppUpdateBanner() {
  const { updateAvailable, applying, applyUpdate } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-[90] px-4 pointer-events-none">
      <div className="mx-auto max-w-xl pointer-events-auto rounded-xl border border-[color:var(--theme-primary)] bg-white px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <span className="w-9 h-9 rounded-lg bg-[color:var(--theme-primary-light)] text-[color:var(--theme-primary)] flex items-center justify-center shrink-0">
          <i className="ri-refresh-line text-lg"></i>
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-gray-900">新しいバージョンがあります</p>
          <p className="text-xs text-gray-600 mt-0.5 leading-relaxed">
            更新すると最新の状態になります。
          </p>
        </div>
        <Button
          variant="primary"
          size="sm"
          onClick={applyUpdate}
          disabled={applying}
          className="shrink-0"
        >
          {applying ? '更新中...' : '更新する'}
        </Button>
      </div>
    </div>
  );
}